import {PostAuthRequestParams} from 'domain/usecases/private/authorizations';
import {makePostAuthRequest} from 'main/factories/usecases/private/authorizations/post-auth-request-factory';

export const postAuthRequest = async (params: PostAuthRequestParams, signal?: AbortSignal) => {
	const response = await makePostAuthRequest().post({...params, signal});
	return response;
};
